import { constants } from "../constants/redux-constants";

const initialState = {
  isDirty: false,
};

const StateReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants?.SET_IS_DIRTY:
      return {
        ...state,
        isDirty: action?.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default StateReducer;
